import { AgGridReact } from "ag-grid-react";
import Cookies from "js-cookie";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { FetchDataTypes } from "../../api/api";
import { Grid, GridReadyEvent } from "ag-grid-community";
import { formateDataCurr, formateDataPrec } from "../../utils/types";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import clsx from "clsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable, { UserOptions } from "jspdf-autotable";
import { boolean } from "yup";
export interface IOlympicData {
  symbol: string;
  date: any;
  status: string;
  order: string;
  qty: string;
  price: number;
}
interface jsPDFCustom extends jsPDF {
  autoTable: (options: UserOptions) => void;
}

const SectorRebalance = () => {
  const [rowData, setRowData] = useState<any>();
  const [rowRebalanceData, setRowRebalanceData] = useState();
  const [newTarger, setNewTarget] = useState<any>();
  const [first, setfirst] = useState([]);
  const [rebalanceTrades, setRebalanceTrades] = useState(false);
  const [showErrormsg, setShowErrormsg] = useState(false);
  const selectedClient:any = Cookies.get("client")
  const dataGridRefMain = useRef<AgGridReact<IOlympicData>>(null);
  
  function newTarget(props: any) {
    return (
      <input
        type="number"
        className="form-control form-control--small m-auto"
        value={newTarger}
        onChange={(e) => setNewTarget(e.target.value)}
      />
    );
  }

  const hashValueGetter = (params: any) => {
    return console.log(params.data);
  };
  useEffect(() => {
    console.log(newTarger);
  }, [first, newTarger]);

  console.log(newTarger);
  const defColumnDefs = useMemo(
    () => ({
      sortable: true,
      //flex:1
    }),
    []
  );

  const [columns, setColumns] = useState([
    { headerName: "Sector Name", field: "sectorName", flex: 1, width: 200 },
    {
      headerName: "Sector Balance",
      field: "sectorBalance",
      sortable: true,
      cellRenderer: formateDataCurr,
      cellClass: "textAlign",
      width: 150,
      headerClass: "headerTextAlign",
    },
    {
      headerName: "Sector Holdings %",
      field: "sectorHoldingsPct",
      cellRenderer: formateDataPrec,
      cellClass: "textAlign",
      width: 150,
      headerClass: "headerTextAlign",
    },
    {
      headerName: "Target %",
      field: "targetPct",
      cellRenderer: formateDataPrec,
      cellClass: "textAlign",
      width: 150,
      headerClass: "headerTextAlign",
    },
    {
      headerName: "Target Balance",
      field: "targetBalance",
      cellRenderer: formateDataCurr,
      cellClass: "textAlign",
      width: 150,
      headerClass: "headerTextAlign",
    },
    {
      headerName: "Buy / Sell",
      field: "buyOrSell",
      cellRenderer: formateDataCurr,
      cellClass: "textAlign",
      width: 150,
      headerClass: "headerTextAlign",
    },
  ]);

  const [inputvalue, setInputvalue] = useState<any>();

  function editableValue(p: any) {
    return (
      <input
        type="number"
        className="form-control"
        value={p.value}
        onChange={() => setInputvalue(p.value)}
      />
    );
  }

  const [columnsRebalanceTrades, setColumnsRebalanceTrades] = useState([
    { headerName: "Sector Name", field: "sectorName", width: 200, flex: 1 },
    {
      headerName: "symbol",
      field: "symbol",
      width: 100,
    },
    {
      headerName: "Qty",
      field: "qty",
      width: 100,
      cellClass: "textAlign",
      headerClass: "headerTextAlign",
    },
    {
      headerName: "Price",
      field: "price",
      sortable: true,
      cellRenderer: formateDataCurr,
      width: 130,
      cellClass: "textAlign",
      headerClass: "headerTextAlign",
    },
    {
      headerName: "Market Value",
      field: "marketValue",
      sortable: true,
      cellRenderer: formateDataCurr,
      cellClass: "textAlign",
      headerClass: "headerTextAlign",
      width: 140,
    },
    {
      headerName: "Buy / Sell",
      field: "buyOrSell",
      //cellRenderer: editableValue,
      cellClass: "textAlign p-0",
      headerClass: "headerTextAlign",
      width: 140,
      editable: true,
    },
    {
      headerName: "Qty Buy / Sell",
      field: "qtyBuyOrSell",
      cellRenderer: formateDataCurr,
      cellClass: "textAlign",
      headerClass: "headerTextAlign",
      width: 140,
    },
    {
      headerName: "Order Type",
      field: "orderType",
      width: 130,
      //cellRenderer: formateDataPrec,
      cellClass: "mx-4",
      headerClass: "mx-4",
    },
  ]);

  function handleSubmit() {
    setRebalanceTrades((current) => !current);
  }
  console.log(rebalanceTrades);
  const onGridReady = useCallback((params: GridReadyEvent) => {
    FetchDataTypes("SectorRebalance", parseInt(selectedClient),Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setRowData(response);
      });
  }, []);

  const onGridReadynew = useCallback((params: GridReadyEvent) => {
    FetchDataTypes("SectorRebalanceTrades", parseInt(selectedClient),Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setRowRebalanceData(response);
      });
  }, []);

  console.log(rowData);

  function showMessage() {
    setShowErrormsg(true);
  }

  const handleExportExcel = useCallback(() => {
    const params = {
      processCellCallback: (params: any) => {
        if (params.column.colId === "dateColumn") {
          // Format date as desired
          return params.value
            ? new Date(params.value).toLocaleDateString()
            : "";
        }
        if (typeof params.value === "string") {
          // Apply currency symbol to string values
          return `${params.value}`;
        }
        if (typeof params.value === "number") {
          // Format numbers as currency with the currency symbol
          return `$${params.value.toFixed(2)}`;
        }
        if (params.column.colId.includes("Locked")) {
          // Render true/false as text
          return params.value; // or return "" + params.value;
        }

        if (params.column.colId.includes("Status")) {
          // Render true/false as text
          return params.value; // or return "" + params.value;
        }
       
        if (typeof params.value === "undefined" ) {
          // Format numbers as currency with the currency symbol
          return `--`;
        }
        return params.value !== null ? `$${params.value}` : "--";
      },
    };

    dataGridRefMain.current?.api.exportDataAsExcel(params);
  }, []);

  const handleExportPdf = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "landscape"; // portrait or landscape
  
    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size) as jsPDFCustom;
  
    doc.setFontSize(8);
  
    const title = "Sector Rebalance";
    const headers = [
      [
        "Sector Name",
        "Sector Balance",
        "Sector HoldingsPct",
        "TargetPct",
        "targetBalance",
        "BuyOrSell"
      ],
    ];
  
    const transactionData = rowData.map((e: any) => [
      e.sectorName !== null ? `${e.sectorName}` : "--",
      e.sectorBalance !== null ? `$${e.sectorBalance}` : "--",
      e.sectorHoldingsPct !== null ? `${e.sectorHoldingsPct}%` : "--",
      e.targetPct !== null ? `${e.targetPct}%` : "--",
      e.targetBalance !== null ? `$${e.targetBalance}` : "--",
      e.buyOrSell !== null ? `$${e.buyOrSell}` : "--",
    ]);
  
    let content = {
      startY: 50,
      head: headers,
      body: transactionData,
    };
  
    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("SectorRebalance.pdf");
  };
  return (
    <div className="mt-4">
      <div className="card mr-2 shadow-none">
        <div className="col-sm-3 w-100 py-3 justify-content-between tableFilters d-flex align-items-baseline">
          <h5 className="card-title float-start">
            Sector Rebalance
            {rebalanceTrades === true ? " - Trades" : null}
          </h5>
          <div className="my-2 justify-content-end d-flex">
          <i
            className="align-middle me-2 far fa-fw fa-file-excel cursor-pointer"
            style={{ fontSize: "16px" }}
            onClick={handleExportExcel}
          ></i>
          <i
            className="align-middle far fa-fw fa-file-pdf cursor-pointer"
            onClick={() => handleExportPdf()}
            style={{ fontSize: "16px" }}
          ></i>
        </div>
        </div>
        {showErrormsg && showErrormsg ? (
          <div
            className="alert alert-danger alert-dismissible position-absolute statusAlert"
            role="alert"
          >
            <div className="alert-message">
ERROR: You have limited access and need approval from admin to execute the trades.</div>
            <button
              type="button"
              className="btn-close btn-close-white"
              data-bs-dismiss="alert"
              aria-label="Close"
            ></button>
          </div>
          
        ) : null}
        <div className="card-body p-0">
          <div className="chart chart-xs">
            <div className="chartjs-size-monitor">
              <div className="chartjs-size-monitor-shrink">
                {rebalanceTrades === true ? (
                  <div
                    className="ag-theme-alpine"
                    style={{
                      height: "600px",
                      width: "100%",
                    }}
                  >
                    <AgGridReact
                      rowData={rowRebalanceData}
                      columnDefs={columnsRebalanceTrades}
                      defaultColDef={defColumnDefs}
                      onGridReady={onGridReadynew}
                      animateRows={true}
                      popupParent={document.body}
                    ></AgGridReact>
                  </div>
                ) : null}
                {rebalanceTrades === false ? (
                  <div
                    className="ag-theme-alpine"
                    style={{
                      height: "600px",
                      width: "100%",
                    }}
                  >
                    <AgGridReact
                      ref={dataGridRefMain}
                      rowData={rowData}
                      columnDefs={columns}
                      defaultColDef={defColumnDefs}
                      onGridReady={onGridReady}
                      animateRows={true}
                      popupParent={document.body}
                    ></AgGridReact>
                  </div>
                ) : null}
              </div>
              <div className="row pt-4">
                <div className="float-end text-end">
                  {rebalanceTrades === true ? (
                    <button
                      type="button"
                      className="btn btn-link"
                      onClick={handleSubmit}
                    >
                      Cancel
                    </button>
                  ) : null}

                  <button
                    type="submit"
                    className={clsx("btn ",
                    rebalanceTrades === true ? 'btn-danger' : 'btn-primary'
                    )}
                    onClick={
                      rebalanceTrades === true ? showMessage : handleSubmit
                    }
                  >
                    {rebalanceTrades === true
                      ? "Place Trades"
                      : "Submit"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { SectorRebalance };
